window.$ = window.jQuery = require('jquery');
var ScrollReveal = require('scrollreveal');
require('bootstrap-sass/assets/javascripts/bootstrap')

$(document).ready(function() {

    window.sr = ScrollReveal({ easing: 'ease-in-out', scale: 1, mobile: false });
    
    var offsetTop = $('body').hasClass('home') ? 0 : 130;
    var siteHeader = $('#site-header');
    var windowWidth = $(window).width();

    if ( windowWidth > 1024 ) {

        siteHeader.affix({
          offset: { top: offsetTop }
        });

        siteHeader.data('bs.affix').options.offset = offsetTop;

    }

    var searchIconDesktop = $('#search-icon-desktop');
    var searchInputDesktop = $('#desktop-search-input');

    searchIconDesktop.click(function(event) {
		event.preventDefault();

    	if ( $(this).hasClass('active') && searchInputDesktop.val().length > 0 ) {
    		window.location = window.location.origin + '?s=' + searchInputDesktop.val();
    	} else if ( $(this).hasClass('active') ) {
            $(this).removeClass('active');
            searchInputDesktop.removeClass('active');
        } else {
    		$(this).addClass('active');
    		searchInputDesktop.addClass('active');
    	}
    });

    var textModul = $('.text_modul .container');
    var teaser = $('.teaser');
    var logo = $('.logo_modul > div');
    var socialIcon = $('.footer-social-links-container');

    if ( $('body').attr('data-scroll-effect') == 'true' ) {
        sr.reveal(textModul, { origin: 'bottom', distance: '150px', viewFactor: 0.2, duration: 1100 });
        sr.reveal(teaser, { origin: 'right', distance: '80px', duration: 1500, viewFactor: 0.2 }, 100);
        sr.reveal(logo, { origin: 'right', distance: '100px', duration: 1200, viewFactor: 0.6 }, 200);
        sr.reveal(socialIcon, { origin: 'right', distance: '100px', duration: 1000, viewFactor: 0.6 }, 50);
    }

    var mobileMenu = $('#mobile-menu');
    var menuBurger = $('#menu-burger');

    menuBurger.click(function() {
        if ( $(this).hasClass('active') ) {
            mobileMenu.removeClass('active');
            $(this).attr('aria-expanded', 'false');
            $(this).removeClass('active');
        } else {
            mobileMenu.addClass('active');
            $(this).attr('aria-expanded', 'true');
            $(this).addClass('active');
        }
    });

    var textModulWrapper = $('.text_modul');

    if ( textModulWrapper.length ) {
        $(textModulWrapper[textModulWrapper.length - 1]).addClass('last-text_modul');
    }

    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

    if ( isSafari && !(window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i))) {
        $('.logo_modul').css('display', '-webkit-box');
    }


    
});